"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _utils = require("./utils");
var _excluded = ["tagName", "toBody", "to", "exitRef", "prerender", "children"];
var Portal = function Portal(props) {
  var _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    toBody = props.toBody,
    _props$to = props.to,
    to = _props$to === void 0 ? toBody ? 'body' : undefined : _props$to,
    exitRef = props.exitRef,
    prerender = props.prerender,
    children = props.children,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var _React$useState = _react.default.useState(null),
    exit = _React$useState[0],
    setExit = _React$useState[1];
  var anchorRefCallback = _react.default.useCallback(function (anchor) {
    if (!anchor) {
      (0, _utils.setRef)(exitRef, null);
      return;
    }
    var exitFound = (0, _utils.findPortalExit)(anchor, to);
    setExit(exitFound);
    (0, _utils.setRef)(exitRef, exitFound);
  }, [to, exitRef]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(tagName, (0, _extends2.default)({
    ref: anchorRefCallback,
    hidden: true
  }, rest), prerender && !exit ? children : null), exit && /*#__PURE__*/(0, _reactDom.createPortal)(children, exit));
};
var _default = Portal;
exports.default = _default;